"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestIds = void 0;
exports.TestIds = {
    root: 'linkElement',
};
//# sourceMappingURL=constants.js.map